<template>
  <div>
    <div class="content">
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <md-card class="md-card-plain">
            <md-card-header>
              <h4 class="title"><b>Mayai Reports</b></h4>
            </md-card-header>
            <md-card-content>
              <template>
                <div class="md-layout md-alignment-top-center mt-6 p-0">
                  <div class="md-layout-item md-size-90 md-medium-size-85 md-xsmall-size-100 p-0">
                    <div class="md-layout md-alignment-top-right">
                      <MonthPicker class="md-layout-item md-alignment-top-right" :hideClearButton="true" @setYear="getYear($event)" @setMonth="getMonth($event)"></MonthPicker>
                    </div>
                  </div>
                </div>
                <div>
                  <md-table v-model="reports">
                    <md-table-row slot="md-table-row" slot-scope="{ item, index }">
                      <md-table-cell>{{ item.name }}</md-table-cell>
                      <md-table-cell>
                        <div>
                          <md-button class="md-just-icon md-simple md-success" @click="downloadReport(index + 1)">
                            <md-icon>download</md-icon>
                            <md-tooltip md-direction="top">Download</md-tooltip>
                          </md-button>
                        </div>
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </div>
              </template>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
    <div class="loading-bar-overlay" v-if="loading">
      <div class="loading-bar">
        <md-progress-bar md-mode="query"></md-progress-bar>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";
import MonthPicker from "@/components/MonthPicker.vue";

export default {
  components: {
    MonthPicker
  },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      loading: false,
      reports: [
        {
          name: "Report 1 - Number of calls per day in a month"
        },
        {
          name: "Report 2 - Number of Free/Paid calls in a month"
        },
        {
          name: "Report 3 - Invoice data for a month"
        },
        {
          name: "Report 4 - Plan Change history"
        },
        {
          name: "Report 5 - Item Change history"
        },
        {
          name: "Report 6 - Billing List Report"
        }
      ],
      call_details: [],
      year: { name: "", value: "" },
      month: { number: null, name: "", days: "" }
    };
  },
  mounted() {
    // this.fetchCustomer();
    this.call_details = [];
  },
  methods: {
    getYear(e) {
      this.year = e;
      // console.log(this.year);
    },
    getMonth(e) {
      this.month = e;
      // console.log(this.month);
    },
    async downloadReport(index) {
      // var params = { month: this.month.number, year: this.year.value };
      this.loading = true;
      var params = { month: this.month.number, year: this.year };
      var response = {};
      if (index === 1) {
        response = await ApiService.get_mayai_per_day_calls(params);
      } else if (index === 2) {
        response = await ApiService.mayai_free_and_paid_calls(params);
      } else if (index === 3) {
        response = await ApiService.invoice_report(params);
      } else if (index === 4) {
        response = await ApiService.plan_change_history(params);
      } else if (index === 5) {
        response = await ApiService.item_change_history(params);
      } else if (index === 6) {
        response = await ApiService.billing_list_report(params);
      }
      if (response.status === 200 && response.data) {
        // console.log(response.data.result);
        // console.log(response.data.data);
        this.call_details = response.data.result;
        this.exportCSV(index);
        this.loading = false;
        this.notifyVue("top", "center", "Report generated", "success");
      } else {
        this.loading = false;
        this.notifyVue("top", "center", "Error generating report", "warning");
      }
    },
    exportCSV(index) {
      var tableHeaders = [];
      if (index === 1 || index === 2 || index === 3 || index === 4 || index === 5 || index === 6) {
        tableHeaders = this.call_details[0];
      }
      var dataTable = new Array();
      dataTable.push(tableHeaders);
      //now looping around the data
      this.call_details.forEach(function(row, index) {
        if (index !== 0) dataTable.push(row);
      });
      // console.log(dataTable.length);
      let csvContent = ""; //"data:text/csv;charset=utf-8,";
      // var i = 0;
      dataTable.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
        // i++;
      });
      // console.log('i=' + i);
      //calling the csv download via anchor tag(link) so we can provide a name for the file
      var encodedUri =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.style.display = "none";
      link.setAttribute(
        "download",
        "call_details_report-" + index + "-" +
          (this.month.name) +
          "_" +
          new Date().getFullYear() +
          ".csv"
      ); //change it to give your own name
      link.innerHTML = "Export";
      document.body.appendChild(link); // Required for FF
      link.click();
      link.remove(); //removing the link after the download
    },
    notifyVue(verticalAlign, horizontalAlign, message, type) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-bar-overlay {
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
}

.loading-bar {
  display: inline;
  z-index: 11;
  position: relative;
  top: 50%;
}
</style>
